import ClosestTournamentData from '../../../models/pages/tournament/ClosestTournamentData';

const transformClosestTournamentData = (data: ClosestTournamentData[]) =>
  data.map((tournament) => ({
    ...tournament,
    format: tournament.format.name,
    ratings: tournament.ratings.map((rating) => rating.name),
  }));

export default transformClosestTournamentData;
